// extracted by mini-css-extract-plugin
var _1 = "ImagePreview-moduleImagePreview__TH2Vw";
export { _1 as "ImagePreview" }
